import React, { useState } from 'react';
import TextareaAutosize from "react-textarea-autosize";
import Text from './Text/Text.tsx';
import ToolCall from './ToolCall/ToolCall.tsx';
import Thinking from './Thinking/Thinking.tsx';

interface TextsAndToolCallsProps {
    offset: number;
    iterObject: any[];
    editedContent: any;
    setEditedContent: any;
    isEditing: boolean;
    focusedLineContents?: {
        content: string;
        language: string;
        filePath: string;
    };
}

const TextComponents: React.FC<TextsAndToolCallsProps> = ({
    offset,
    iterObject,
    editedContent = null,
    setEditedContent = null,
    isEditing,
    focusedLineContents
}) => {
    const [isHighlightedCodeExpanded, setIsHighlightedCodeExpanded] = useState(false);

    const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>, index: number) => {
        const updatedContent = [...editedContent];
        updatedContent[index].text = e.target.value;
        setEditedContent(updatedContent);
    };

    const getComponentForType = (item: any, index: number) => {
        if (item.type === "text") return <Text key={index} item={item} index={index} />;
        else if (item.type === "thinking" || item.type === "redacted_thinking") return <Thinking key={index} item={item} />;
        else return <ToolCall key={index} item={item} />;
    }

    return (
        <>
            {focusedLineContents && (
                <div className={`my-3 ${isHighlightedCodeExpanded ? "border border-black rounded-2xl p-4" : ""}`}>
                    <div>
                        <button
                            onClick={() => setIsHighlightedCodeExpanded(!isHighlightedCodeExpanded)}
                            className="flex items-center gap-2 mb-2 text-sm font-medium text-neutral-700 dark:text-neutral-300 hover:text-neutral-900 dark:hover:text-neutral-100 transition-colors"
                        >
                            <span>
                                ▶
                            </span>
                            Highlighted Code
                        </button>
                        {isHighlightedCodeExpanded && (
                            <div className={"-space-y-2.5 -mb-5"}>
                                <Text item={{ text: `[${focusedLineContents.filePath}](${focusedLineContents.filePath})` }} index={0} />
                                <Text item={{text: `\`\`\`${focusedLineContents.language}\n${focusedLineContents.content}\n\`\`\``,}} index={0}/>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {iterObject.length > 0 && (
                <div>
                    {isEditing ? (
                        iterObject.map((item: any, index: number) => {
                            const textIndex = offset + index;

                            return (
                                <TextareaAutosize
                                    key={index}
                                    value={item.text}
                                    onChange={(e) => handleContentChange(e, textIndex)}
                                    className="bg-inherit resize-none w-96 max-w-full whitespace-pre-line"
                                    minRows={3}
                                />
                            );
                        })
                    ) : (
                        iterObject.map((item: any, index: number) => (
                            getComponentForType(item, index)
                        ))
                    )}
                </div>
            )}
        </>
    );
};

export default TextComponents;